import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($) {

    const sentenceEditor = $('#sentences-editor');
    if (sentenceEditor.length) {
        let multiEdit = $('#multiedit');

        sentenceEditor.editableTableWidget();

        multiEdit.on('change', '#move_sentences', function () {
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Sätze verschoben werden?")) {
                    let selected = sentenceEditor.find('input.sentence-check:checked');
                    let selectedRows = selected.map(function () {
                        return $(this).parents('tr');
                    }).get();
                    let selectedWords = selected.map(function () {
                        return this.value;
                    }).get();

                    if (selectedWords.length > 0) {
                        $.get('/admin/sentences/move?id=' + selectedWords.join(',') + '&sg=' + groupId);
                        $.each(selectedRows, function (i, row) {
                            row.find('button[data-action="move"]').toggleClass('active');
                            row.find('.move-select').toggleClass('d-none');
                            row.find('td').addClass('bg-warning');
                            window.setTimeout(function () {
                                row.remove();
                            }, 280)
                        });
                        toast('Es wurden ' + selectedWords.length + ' Sätze nach "'+ targetName + '" verschoben', 'Sätze verschieben');
                    }
                }
            }
        });
        multiEdit.on('change', '#copy_sentences', function(){
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Sätze kopiert werden?")) {
                    let selected = sentenceEditor.find('input.sentence-check:checked');
                    let selectedWords = selected.map(function(){ return this.value; }).get();
                    if (selectedWords.length > 0) {
                        $.get('/admin/sentences/copy?id=' + selectedWords.join(',') + '&sg=' + groupId);
                        toast('Es wurden ' + selectedWords.length + ' Sätze nach "'+ targetName + '" kopiert', 'Sätze kopieren');
                    }

                    this.selectedIndex = 0;
                }
            }
        });

        sentenceEditor.on('click', 'input.sentence-check', function () {
            let selected = sentenceEditor.find('input.sentence-check:checked');
            let selectedWords = selected.map(function () {
                return this.value;
            }).get();
            if (selectedWords.length > 0) {
                multiEdit.show();
            } else {
                multiEdit.hide();
            }
        });


        sentenceEditor.on('change', 'td', function(evt, newValue) {
            let tr = $(this).parent();
            let field = $(this).data('field');
            let id = tr.data('row');
            let url = sentenceEditor.data('url');

            let data = {};
            data['id'] = id;
            data['field'] = field;
            data['value'] = newValue;

            console.log(data);
            $.post(url, data, function(r){
                console.log(r);
            });
        });

        sentenceEditor.on('click', 'button', function(e) {
            let button = $(this);
            let url = sentenceEditor.data('del');
            e.preventDefault();

            if ($(this).data('action') === 'delete') {
                if (confirm('Wollen Sie den Satz wirklich löschen?')) {
                    let tr = $(this).parents('tr');
                    let id = tr.data('row');

                    let data = {};
                    data['id'] = id;

                    $.post(url, data, function(r){
                        console.log(r);
                        tr.remove();
                    });
                }
            }

            if ($(this).data('action') === 'move') {
                button.toggleClass('active');
                button.parents('tr').find('.move-select').toggleClass('d-none');
            }
        });



        $('#sentence-filter select').on('change', function(e) {
            $(this).parents('form').submit();
        });

        $('#sentence-filter input[type="search"]').on('input', function(e) {
            if (!e.currentTarget.value && !e.inputType) {
                $(this).parents('form').submit();
            }
        });

    }

});



